export * from './spinner.component';
export * from './spinner-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/spinner/index.ts